import classNames from "classnames";
import { Spinner } from "~/components/Spinner";
import { Text } from "~/components/Text";
import { formatMeters } from "~/utils/formatMeters";
import { Radio } from "../Radio";
import { usePickupPointSelector } from "./usePickupPointSelector";
import { stringToCurrency } from "~/utils/stringConversion";

type Props = {
  className?: string;
};

const getPrice = (price?: number) => {
  return price ? stringToCurrency({ amount: price }) : "Gratis";
};

export const PickupPointSelector = ({ className }: Props) => {
  const {
    pickupPointsWithQuotes,
    homeDeliveryQuote,
    isLoading,
    onSelectLocation,
    hasFreeDelivery,
  } = usePickupPointSelector();

  if (!pickupPointsWithQuotes.length && !homeDeliveryQuote) return null;

  return (
    <div className={classNames(className)}>
      <Text>Vælg leveringsmetode</Text>
      <ul>
        {isLoading ? (
          <Spinner
            fillClass="fill-secondary"
            className="flex justify-center mt-4"
          />
        ) : (
          <div className="mt-6">
            {pickupPointsWithQuotes.map((pickupPoint) => (
              <Radio
                key={pickupPoint.id}
                id={`pickupPoint-${pickupPoint.id}`}
                groupName="pickup-point-selector"
                className="grid grid-cols-[auto_4fr] gap-4 mt-4 !pr-0 !text-left !items-start"
                checkmarkClassName="!static order-[-1]"
                onChange={() =>
                  onSelectLocation(pickupPoint.quote, pickupPoint)
                }
              >
                <li className="grid grid-cols-[3fr_1fr] cursor-pointer">
                  <div className="self-start">
                    <Text className="text-sm leading-[1]">
                      {pickupPoint.name} ({formatMeters(pickupPoint.distance)})
                    </Text>
                    <Text className="text-xs mt-2">
                      {pickupPoint.address}, {pickupPoint.zipcode}{" "}
                      {pickupPoint.city}
                    </Text>
                  </div>
                  <Text className="text-right leading-[1]">
                    {getPrice(hasFreeDelivery ? 0 : pickupPoint.quote?.price)}
                  </Text>
                </li>
              </Radio>
            ))}
            {homeDeliveryQuote && (
              <Radio
                id={"homeDelivery"}
                groupName="pickup-point-selector"
                className="grid grid-cols-[auto_4fr] gap-4 !pr-0 !text-left !items-start mt-4"
                checkmarkClassName="!static order-[-1]"
                onClick={() => onSelectLocation(homeDeliveryQuote)}
              >
                <li className="grid grid-cols-[3fr_1fr] cursor-pointer">
                  <div className="self-start">
                    <Text className="text-sm leading-[1]">
                      Omdeling til privat
                    </Text>
                  </div>
                  <Text className="text-right leading-[1]">
                    {getPrice(hasFreeDelivery ? 0 : homeDeliveryQuote.price)}
                  </Text>
                </li>
              </Radio>
            )}
          </div>
        )}
      </ul>
    </div>
  );
};
